import { realApi } from './api';

// Festivos, avisos y eventos de la temporada (sorteos, comienzo/fin de
// liga...) que se muestran en /calendario. Lectura pública; alta/edición/
// borrado solo ADMIN/COMITE (ver 08_calendario_eventos.sql en badminton-api).
// Sin relación con jornadas/partidos: es una lista curada a mano.
export const getEventosCalendarioReal = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/calendario-eventos`).then((r) => r.datos);

export const crearEventoCalendarioReal = (temporadaId, datos) =>
  realApi.post(`/temporadas/${encodeURIComponent(temporadaId)}/calendario-eventos`, datos);

export const actualizarEventoCalendarioReal = (id, datos) =>
  realApi.patch(`/calendario-eventos/${id}`, datos);

export const borrarEventoCalendarioReal = (id) =>
  realApi.delete(`/calendario-eventos/${id}`);
